<div class="profile-content">
  <div class="row">
    <div class="col-md-12">
      <div class="caption caption-md">
        <span class="caption-subject">Security</span>
        <span class="caption-sub-subject">Change your password below</span>
      </div>
    </div>

    <form [formGroup]="changePasswordForm" (ngSubmit)="submit()" class="contactus-forms">
      <div *ngIf="isErrorpwd" class="input-error col-12 col-md-6 col-lg-4">
        Old password and new password is same, please enter different password
      </div>

      <div class="form-group col-12 col-md-6 col-lg-4 mt-2">
        <piqet-angular-common-input
          formControlName="oldPassword"
          [control]="changePasswordForm.get('oldPassword')"
          label="Old password"
          placeholder="Enter Old password"
          [maxLength]="50"
          [inputType]="'password'"
          [showPasswordToggle]="true"
          (keyupEvent)="comparePasswords()"
          [errorMessages]="{
            required: 'The old password field is required.',
            whitespace: 'The old password field is required.'
          }"
        >
        </piqet-angular-common-input>
      </div>

      <div class="form-group col-12 col-md-6 col-lg-4">
        <piqet-angular-common-input
          formControlName="Password"
          [control]="changePasswordForm.get('Password')"
          label="New password"
          placeholder="Enter New password"
          [maxLength]="50"
          [inputType]="'password'"
          [showPasswordToggle]="true"
          (keyupEvent)="validationsPassword()"
        >
        </piqet-angular-common-input>

        <!-- Keep the security tabs outside the input component -->
        <div class="security-tabs">
          <p [ngClass]="upperCaseCharactersflag ? 'hightlightText' : 'NonhightlightText'">
            One uppercase character
          </p>
          <p [ngClass]="lowerCaseCharactersflag ? 'hightlightText' : 'NonhightlightText'">
            One lowercase character
          </p>
          <p [ngClass]="numberCharactersflag ? 'hightlightText' : 'NonhightlightText'">
            One number
          </p>
          <p [ngClass]="specialCharactersflag ? 'hightlightText' : 'NonhightlightText'">
            One special character
          </p>
          <p [ngClass]="minLengthsflag ? 'hightlightText' : 'NonhightlightText'">
            8 characters minimum
          </p>
        </div>
      </div>

      <div class="form-group col-12 col-md-6 col-lg-4">
        <piqet-angular-common-input
          formControlName="ConfirmPassword"
          [control]="changePasswordForm.get('ConfirmPassword')"
          label="Confirm password"
          placeholder="Enter Confirm password"
          [maxLength]="50"
          [inputType]="'password'"
          [showPasswordToggle]="true"
          (keyupEvent)="comparePasswords()"
          [errorMessages]="{
            required: 'The confirm password field is required.',
            mustMatch: 'The password and confirm password fields do not match'
          }"
        >
        </piqet-angular-common-input>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <button
            type="submit"
            class="submitBtn purpleBtnHoverEffect"
            [disabled]="!changePasswordForm.valid || !submitted"
          >
            <p>Update</p>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
